<template>
  <div v-if="item.address || item.acf.use_tribe_address">
    <h3 class="text-transform_unset text-black">Adresse(s)</h3>
    <p v-if="addressLoaded" :class="{ 'pb-0' : getLatLng }">{{ item.address }}</p>
    <p v-if="addressLoaded && getLatLng">{{ getLatLng }}</p>
    <p v-else-if="!addressLoaded">Chargement de l'adresse en cours...</p>
  </div>
</template>


<script>
import HttpClient from "@/services/api/api";

export default {
  name: 'Address',

  data() {
    return {
      addressLoaded: false
    }
  },

  mounted() {
    this.getAddress();
  },

  updated() {
    if (!this.item.address) {
      this.getAddress();
    }
  },

  props: {
    item: Object
  },

  methods: {
    async getAddress() {
      if (this.item.acf.use_tribe_address) {
        const venueObj = await HttpClient.getVenue(this.item.acf.venue.ID);
        this.item.address = [venueObj.address, venueObj.zip, venueObj.city].join(', ');
      }

      this.item.address = this.item.acf.location.address;
      this.addressLoaded = true;
    },
  },

  computed: {
    getLatLng() {
      if (this.item.type !== 'equipement' || !this.item.acf.location.lat || !this.item.acf.location.lng) {
        return false;
      }

      return [this.item.acf.location.lat, this.item.acf.location.lng].join(', ');
    }
  }

}
</script>
